import React, { Component } from 'react';
import { Card, Box, CardContent, CardActions, CardHeader, Button } from '@material-ui/core';



class CardFormLayout extends Component {
    state = {  }
    render() {
        const { title, submitButton } = this.props;

        return (
            <Card>
                {title && <CardHeader title={title} /> }
                <CardContent>
                    {this.props.children}
                    
                </CardContent>
                <CardActions style={{ justifyContent: "end"}} >
                    <Box p={2}>
                        {submitButton ?
                            submitButton
                        :
                            <Button 
                                disabled={this.props.disabled} 
                                onClick={this.props.handleSubmit}
                                color="secondary"
                                variant="contained"
                            >
                                {this.props.submitTitle || "Valider"}
                            </Button>
                        }
                        <Button 
                            disabled={this.props.disabled} 
                            onClick={this.props.cancelSubmit}
                            color="secondary"
                        >
                            Annuler
                        </Button>
                    </Box>
                </CardActions>
            </Card>
        );
    }
}
export default CardFormLayout;